import baysportLogo from "../assets/logo.png";
import { mediaUrl } from "./clientHeroTheme";

const iconCache = new Map();
const blobUrls = new Set();

export const DEFAULT_PWA_ICONS = [
  {
    src: "/icons/icon-192.png",
    sizes: "192x192",
    type: "image/png",
    purpose: "any",
  },
  {
    src: "/icons/icon-512.png",
    sizes: "512x512",
    type: "image/png",
    purpose: "any",
  },
  {
    src: "/icons/icon-maskable.png",
    sizes: "512x512",
    type: "image/png",
    purpose: "maskable",
  },
];

export const DEFAULT_APPLE_TOUCH_ICON = "/apple-touch-icon.png";
export const DEFAULT_FAVICON = "/favicon.ico";

function resolveMediaUrl(url) {
  if (!url) return null;
  const value = String(url).trim();
  if (!value) return null;
  if (/^(https?:|blob:|data:)/i.test(value)) return value;
  return mediaUrl(value) || value;
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("image load failed"));
    img.src = resolveMediaUrl(src) || src;
  });
}

function canvasToBlobUrl(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("canvas blob failed"));
        return;
      }
      const url = URL.createObjectURL(blob);
      blobUrls.add(url);
      resolve(url);
    }, "image/png");
  });
}

function pickIconBackground(accentColor) {
  const c = String(accentColor || "").trim();
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(c)) return c;
  return "#0f1117";
}

async function renderSquareIcon(img, size, backgroundColor) {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("canvas context unavailable");

  ctx.fillStyle = backgroundColor;
  ctx.fillRect(0, 0, size, size);

  const padding = size * 0.12;
  const inner = size - padding * 2;
  const scale = Math.min(inner / img.width, inner / img.height);
  const w = img.width * scale;
  const h = img.height * scale;
  ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);

  return canvasToBlobUrl(canvas);
}

/**
 * Квадратные PNG для manifest / apple-touch-icon из логотипа клуба или BaySport.
 */
export async function buildPersonalizedPwaIcons(logoSrc, accentColor) {
  const source = logoSrc || baysportLogo;
  const cacheKey = `${source}|${accentColor || ""}`;
  if (iconCache.has(cacheKey)) return iconCache.get(cacheKey);

  try {
    const img = await loadImage(source);
    const bg = pickIconBackground(accentColor);
    const [icon192, icon512, iconMaskable] = await Promise.all([
      renderSquareIcon(img, 192, bg),
      renderSquareIcon(img, 512, bg),
      renderSquareIcon(img, 512, bg),
    ]);

    const icons = [
      { src: icon192, sizes: "192x192", type: "image/png", purpose: "any" },
      { src: icon512, sizes: "512x512", type: "image/png", purpose: "any" },
      {
        src: iconMaskable,
        sizes: "512x512",
        type: "image/png",
        purpose: "maskable",
      },
    ];
    iconCache.set(cacheKey, icons);
    return icons;
  } catch {
    return null;
  }
}

export function revokePwaIconBlobs() {
  for (const url of blobUrls) URL.revokeObjectURL(url);
  blobUrls.clear();
  iconCache.clear();
}
